export function NotFound() { return <div className="p-6 text-center"><h1 className="text-4xl font-bold">404</h1><p>Page Not Found</p></div>; }
